import styled from 'styled-components'

export const StyledAdminTemplate = styled.div<{ showAdd: boolean }>`
  display: ${(props) => (props.showAdd ? 'none' : 'flex')};
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
  background-color: #f3f4f8;
  gap: 2rem;
  padding: 1rem;
`

export const StyledImg = styled.img`
  width: 9rem;
  height: 9rem;
  object-fit: contain;
`

export const GoBack = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  top: 0;
  background-color: ${(props) => props.theme.colors.grey};
  z-index: 10;
  width: 70%;
  padding: 1rem;
  box-sizing: border-box;
  border-bottom: 1px solid ${(props) => props.theme.colors.red};
`
export const StyledIcons = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2rem;
  cursor: pointer;
`
export const StyledA = styled.a`
  text-decoration: none;
  color: ${(props) => props.theme.colors.black};
`
export const Navigaton = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  width: 70%;
  flex-direction: row-reverse;
`
export const NavigationItem = styled.div`
  display: flex;
`
